import Cookie from "js-cookie"

export const UTM_KEY = "TILDAUTM"

export function getTildaUtm() {
    return Cookie.get(UTM_KEY) || ""
}
